import React from 'react';
import { Box, Typography } from '@mui/material';
import AudioContainerPreview from '../Common/AudioContainerPreview';

const SessionAudioComponent = ({
  audio,
  audioPreview,
  onAudioUpload,
  onAudioRemove,
  onAudioLoadedData,
  contentStartTimestamp,
  onContentStartChange,
  ratingStart,
  ratingEnd,
  onRatingStartChange,
  onRatingEndChange,
  showRating = false
}) => {
  return (
    <Box>
      <AudioContainerPreview
        title="Session Audio"
        audio={audioPreview || audio}
        name="session_main_url"
        handleRemove={onAudioRemove}
        handleAudioUpload={onAudioUpload}
        onLoadedData={onAudioLoadedData}
        showCopyUrlButton={true}
        sx={{ height: '100%' }}
      />
    </Box>
  );
};

export default SessionAudioComponent; 